import { commonUtil } from '@/util'
const request = {}

request.createRequest = function ({
  searchDetailInfo,
  searchHeaderInfo,
  page
}) {
  return {
    loadingStartDate: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line1.loadingDate.start
    ),
    loadingEndDate: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line1.loadingDate.end
    ),
    supplierIds: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line1.supplierName
        .map((supplierName) => {
          return supplierName.value
        })
        .join(',')
    ),
    storageId: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line1.loadingStorage.value
    ),
    status: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line1.loadingStatus?.value
    ),
    orderControlNumber: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line2.orderInfo.saleNumber
    ),
    loadingControlNumber: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line2.orderInfo.remittanceNumber
    ),
    productNumber: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line2.productInfo.number
    ),
    productName: commonUtil.nullEmptyFormatNull(searchHeaderInfo.productName),
    productCategoryId: commonUtil.nullEmptyFormatNull(
      searchDetailInfo.line2.productInfo.category.value
    ),
    invalidLoadingDisplay: searchHeaderInfo.InvalidData ? 0 : 1,
    page: commonUtil.nullEmptyFormatNull(page)
  }
}
export default { request }
